import { signal } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * @deprecated Use pure signals instead of BaseStore
 * This class is kept for backward compatibility
 */
export class BaseStore<T = any> {
  protected readonly state$ = new Subject<T>();
  protected readonly state = signal<T | undefined>(undefined);

  constructor(initialState: T) {
    this.state.set(initialState);
    this.state$.next(initialState);
  }

  protected updateState(partialState: Partial<T>) {
    const newState = {
      ...this.state()!,
      ...partialState,
    };
    this.state.set(newState);
    this.state$.next(newState);
  }

  protected get(): T {
    return {
      ...this.state()!,
    };
  }
}
